"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdFieldToJSON = exports.AdFieldFromJSONTyped = exports.AdFieldFromJSON = exports.AdField = void 0;
/**
 *
 * @export
 */
exports.AdField = {
    AdAccountId: 'AD_ACCOUNT_ID',
    AdvertiserName: 'ADVERTISER_NAME',
    AdPreviewUrl: 'AD_PREVIEW_URL',
    AdSetId: 'AD_SET_ID',
    Assets: 'ASSETS',
    CampaignId: 'CAMPAIGN_ID',
    CallToAction: 'CALL_TO_ACTION',
    CreatedAt: 'CREATED_AT',
    Delivery: 'DELIVERY',
    Id: 'ID',
    Name: 'NAME',
    RejectReason: 'REJECT_REASON',
    Status: 'STATUS',
    Tagline: 'TAGLINE',
    ThirdPartyTracking: 'THIRD_PARTY_TRACKING',
    UpdatedAt: 'UPDATED_AT',
    SlotPositions: 'SLOT_POSITIONS',
    NotaryMetadata: 'NOTARY_METADATA',
    DvClientCode: 'DV_CLIENT_CODE',
    Placements: 'PLACEMENTS',
    AssetUri: 'ASSET_URI',
    Survey: 'SURVEY'
};
function AdFieldFromJSON(json) {
    return AdFieldFromJSONTyped(json, false);
}
exports.AdFieldFromJSON = AdFieldFromJSON;
function AdFieldFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.AdFieldFromJSONTyped = AdFieldFromJSONTyped;
function AdFieldToJSON(value) {
    return value;
}
exports.AdFieldToJSON = AdFieldToJSON;
